import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const BASE_URL = `${API_BASE_URL}/suppliers/`;

const getHeaders = () => ({
  'Authorization': `Token ${authService.getToken()}`,
  'Content-Type': 'application/json'
});

const suppliersService = {
  /**
   * Lists suppliers. Takes an options object rather than positional arguments:
   * with six independent filters a positional signature forces callers to pad
   * with nulls, which is how `listSuppliers(null, null, query)` used to read.
   * Same convention as purchasesService.
   */
  listSuppliers: ({
    filterField = null,
    filterValue = null,
    search = null,
    ordering = '-created_at',
    page = 1,
    includeInactive = false
  } = {}) => {
    const params = { ordering, page };

    if (search) params.search = search;
    if (filterField && filterValue) params[filterField] = filterValue;
    if (includeInactive) params.include_inactive = 'true';

    return axios.get(BASE_URL, {
      headers: getHeaders(),
      params
    });
  },

  getSupplierById: (id) => {
    return axios.get(`${BASE_URL}${id}/`, {
      headers: getHeaders()
    });
  },

  createSupplier: (data) => {
    return axios.post(BASE_URL, data, {
      headers: getHeaders()
    });
  },

  updateSupplier: (id, data) => {
    return axios.patch(`${BASE_URL}${id}/`, data, {
      headers: getHeaders()
    });
  },

  toggleActive: (id) => {
    return axios.patch(`${BASE_URL}${id}/toggle_active/`, {}, {
      headers: getHeaders()
    });
  }
};

export default suppliersService;
